import { render, staticRenderFns } from "./base_archived.vue?vue&type=template&id=655dd12f&scoped=true&"
import script from "./base_archived.vue?vue&type=script&lang=js&"
export * from "./base_archived.vue?vue&type=script&lang=js&"
import style0 from "./base_archived.vue?vue&type=style&index=0&id=655dd12f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655dd12f",
  null
  
)

export default component.exports